/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S1_P2Inputs */

const tr_iade_iptal_s1_p2 = /** @type {(inputs: Iade_Iptal_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politika; 6502 sayılı Tüketicinin Korunması Hakkında Kanun, Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246), Mesafeli Sözleşmeler Yönetmeliği (RG 27.11.2014, son değişiklik 24.05.2025) ve 6698 sayılı Kişisel Verilerin Korunması Kanunu çerçevesinde hazırlanmıştır.`)
};

const en_iade_iptal_s1_p2 = /** @type {(inputs: Iade_Iptal_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Policy has been prepared within the framework of 6502 sayılı Tüketicinin Korunması Hakkında Kanun, Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246), Mesafeli Sözleşmeler Yönetmeliği (RG 27.11.2014, last amended 24.05.2025) and 6698 sayılı Kişisel Verilerin Korunması Kanunu.`)
};

const de_iade_iptal_s1_p2 = /** @type {(inputs: Iade_Iptal_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Richtlinie wurde im Rahmen des 6502 sayılı Tüketicinin Korunması Hakkında Kanun, der Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246), der Mesafeli Sözleşmeler Yönetmeliği (RG 27.11.2014, letzte Änderung 24.05.2025) und des 6698 sayılı Kişisel Verilerin Korunması Kanunu erstellt.`)
};

const ru_iade_iptal_s1_p2 = /** @type {(inputs: Iade_Iptal_S1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика подготовлена в рамках 6502 sayılı Tüketicinin Korunması Hakkında Kanun, Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı 29246), Mesafeli Sözleşmeler Yönetmeliği (RG 27.11.2014, последнее изменение 24.05.2025) и 6698 sayılı Kişisel Verilerin Korunması Kanunu.`)
};

/**
* | output |
* | --- |
* | "The Policy has been prepared within the framework of 6502 sayılı Tüketicinin Korunması Hakkında Kanun, Abonelik Sözleşmeleri Yönetmeliği (RG 24.01.2015, sayı..." |
*
* @param {Iade_Iptal_S1_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s1_p2 = /** @type {((inputs?: Iade_Iptal_S1_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S1_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s1_p2(inputs)
	if (locale === "de") return de_iade_iptal_s1_p2(inputs)
	if (locale === "ru") return ru_iade_iptal_s1_p2(inputs)
	return tr_iade_iptal_s1_p2(inputs)
});